import { Menu, theme } from 'antd';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/AuslinkLogo.png';
import { AiOutlineUser, AiOutlineDashboard, AiOutlineSetting, AiOutlineArrowLeft, AiOutlineCloudUpload, AiFillBank } from 'react-icons/ai';
import { FiHelpCircle } from 'react-icons/fi';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedClient, setSelectedPrimaryClient } from '../../store/action/selected';
import { user_role } from '../../consts';
import ToolBar from './Toolbar';
import { normalizeString } from '../../utils/pathUtils';

function Sidenav() {
  const { pathname } = useLocation();
  const page = pathname.replace('/', '');
  const navigate = useNavigate();
  const {
    token: { colorPrimary },
  } = theme.useToken();
  let { name: companyName } = useSelector((st) => st.selected.company || {});
  const selectedClient = useSelector((st) => st.selected.primaryClient || {});
  const dispatch = useDispatch();
  let { role } = useSelector((st) => st.user);
  const user = useSelector((st) => st.user);
  const userData = useSelector((st) => st.user);
  const { primary_client_first_logged_in } = userData;

  // Helper function to build paths with selected client ID when applicable
  const buildPath = (path) => {
    if (selectedClient?._id) {
      return `/${normalizeString(companyName)}/${selectedClient._id}${path}`;
    }
    return `/${normalizeString(companyName)}${path}`;
  };

  // Helper function to check if current page matches with selected client path
  const isActivePage = (targetPath) => {
    if (selectedClient?._id) {
      return pathname === `/${normalizeString(companyName)}/${selectedClient._id}${targetPath}`;
    }
    return pathname === `/${normalizeString(companyName)}${targetPath}`;
  };

  const items = [
    {
      key: "1",
      label: (
        <NavLink to={buildPath("")} end style={{ textDecoration: "none" }}>
          <span
            className="icon"
            style={{ background: isActivePage("") ? colorPrimary : "" }}
          >
            <AiOutlineDashboard
              style={{ filter: isActivePage("") ? "brightness(1000%)" : "none" }}
            />
          </span>
          <span
            className="label"
            style={{ fontWeight: isActivePage("") ? "600" : "none" }}
          >
            Dashboard
          </span>
        </NavLink>
      ),
      style: { background: isActivePage("") ? "#fff" : "" },
    },

    {
      key: "3",
      label: (
        <NavLink to={buildPath("/entities")} style={{ textDecoration: "none" }}>
          <span
            className="icon"
            style={{
              minWidth: "32px",
              background: isActivePage("/entities") ? colorPrimary : "",
            }}
          >
            <AiOutlineSetting
              style={{
                filter: isActivePage("/entities") ? "brightness(1000%)" : "none",
              }}
            />
          </span>
          <span
            className="label"
            style={{
              fontWeight: isActivePage("/entities") ? "600" : "normal",
            }}
          >
            Entities
          </span>
        </NavLink>
      ),
      style: { background: isActivePage("/entities") ? "#fff" : "" },
    },
  ];
  if (
    (role === user_role.ADMIN ||
      role === user_role.STAFF ||
      (role === user_role.ACCOUNTANT &&
        (user?.can_invite_accountant || user?.can_invite_staff))) &&
    !selectedClient?._id
  ) {
    items.push({
      key: "4",
      label: (
        <NavLink to="/users" style={{ textDecoration: "none" }}>
          <span
            className="icon"
            style={{ background: page === "users" ? colorPrimary : "" }}
          >
            <AiOutlineUser />
          </span>
          <span className="label">
            {role === user_role.STAFF ? "Primary Clients" : "Users"}
          </span>
        </NavLink>
      ),
    });
  }

  if (selectedClient?._id || role === user_role.PRIMARY_CLIENT) {
    items.push({
      key: "drive",
      label: (
        <NavLink to={buildPath("/drive")} style={{ textDecoration: "none" }}>
          <span
            className="icon"
            style={{
              background: isActivePage("/drive") ? colorPrimary : "",
            }}
          >
            <AiOutlineCloudUpload
              style={{
                filter: isActivePage("/drive") ? "brightness(1000%)" : "none",
              }}
            />
          </span>
          <span
            className="label"
            style={{
              fontWeight: isActivePage("/drive") ? "600" : "normal",
            }}
          >
            Drive
          </span>
        </NavLink>
      ),
      style: { background: isActivePage("/drive") ? "#fff" : "" },
    });
  }

  if (role === user_role.ADMIN && !selectedClient?._id) {
    items.push({
      key: "firms",
      label: (
        <NavLink to="/firms" style={{ textDecoration: "none" }}>
          <span
            className="icon"
            style={{ background: page === "firms" ? colorPrimary : "" }}
          >
            <AiFillBank />
          </span>
          <span className="label">Firms Management</span>
        </NavLink>
      ),
    });
  }

  if (!primary_client_first_logged_in) {
    items.push({
      key: "6",
      label: (
        <NavLink to="/help-center" style={{ textDecoration: "none" }}>
          <span
            className="icon"
            style={{ background: page === "help-center" ? colorPrimary : "" }}
          >
            <FiHelpCircle
              style={{ color: page === "help-center" ? "#fff" : "#afafafff" }}
            />
          </span>
          <span className="label">Help</span>
        </NavLink>
      ),
    });
  }

  return (
    <>
      {role !== user_role.PRIMARY_CLIENT && !selectedClient?._id && (
        <div className="brand text-center">
          <img src={logo} alt="AusLink" style={{ height: '100px' }} />
        </div>
      )}

      {
        selectedClient?._id || role === user_role.PRIMARY_CLIENT ? (
          <div className="brand text-center">
            {selectedClient?._id && <div className="mb-2">
              <div
                className="text-primary cursor-pointer flex items-center"
                onClick={() => {
                      try {
                        dispatch(setSelectedPrimaryClient({}));
                        dispatch(setSelectedClient({}));
                      } catch (e) {
                        console.error('Dispatch error while clearing selection', e);
                      }
                      navigate(`/${normalizeString(companyName)}`, { replace: true });
                    }}
                style={{ marginBottom: '20px', fontSize: '12px', fontWeight: 'normal', cursor: 'pointer' }}
              >
                <AiOutlineArrowLeft /> {' '}
                Back to Main Menu
              </div>
            </div>}

            {/* <img src={selectedClient?.logo} alt="AusLink" style={{ height: '100px' }} /> */}

            <div className="mt-2">
              <div style={{ fontWeight: 'bold', fontSize: '20px' }}>{companyName}</div>
              <div>{selectedClient?.first_name} {selectedClient?.last_name}</div>
            </div>
          </div>
        ) :
          null
      }

      <hr />
      <Menu
        theme="light"
        mode="inline"
        style={{ minWidth: "10vw" }}
        items={items}
      />

      {/* Toolbar only for non-primary clients */}
      {role !== user_role.PRIMARY_CLIENT && <ToolBar />}
    </>
  );
}

export default Sidenav;